import React, { forwardRef, memo, useImperativeHandle } from 'react';

import { useDisclosure } from '@chakra-ui/hooks';

import { washHub } from 'store/slices';

import { createEquipmentInventory } from 'api/equipment';
import { useMutation, useQueryClient } from 'react-query';

import { successToast } from 'utils/successToast';

import { RefType, AddEquipmentModalProps } from './AddEquipmentModal.props';

import AddEquipmentModalView from './AddEquipmentModal.view';

const Container = forwardRef<RefType, AddEquipmentModalProps>((_, ref) => {
  const queryClient = useQueryClient();

  const washHubId = washHub.selectors.useSelectedWashHubId();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const { mutate, isLoading } = useMutation(createEquipmentInventory, {
    onSuccess: (_, { quantity }) => {
      successToast(
        quantity === 1
          ? '1 equipment unit added'
          : `${quantity} equipment units added`,
      );

      queryClient.invalidateQueries(`fetch-equipment-inventory-${washHubId}`);
      queryClient.invalidateQueries(
        `fetch-equipment-status-count-${washHubId}`,
      );

      onClose();
    },
  });

  useImperativeHandle(
    ref,
    () => ({
      onOpen,
    }),
    [onOpen],
  );

  const onSubmit = (values: any) => {
    mutate({
      sku: values.sku,
      quantity: Number(values.quantity || '0'),
      washHub: washHubId,
    });
  };

  const _props = {
    isOpen,
    onClose,
    onSubmit,
    isLoading,
  };

  return <AddEquipmentModalView {..._props} />;
});

const AddEquipmentModal = memo(Container);

export default AddEquipmentModal;
